import agent from './agent'
import material from './material'
import gen from './gen'
import explore from './explore'
import asr from './asr'
import site from './site'
import autojs from './autojs'
import creator from './creator'

export default [
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/admin/admin.vue'),
    meta: { title: '后台管理', requireAuth: true, requireAdmin: true },
    redirect: '/admin/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/admin/dashboard/dashboard.vue'),
        meta: { title: '后台首页', tabbar: 'dashboard' }
      },
      {
        path: 'user',
        name: 'user',
        component: () => import('@/views/admin/user/user.vue'),
        meta: { title: '用户管理', tabbar: 'user' }
      },
      {
        path: 'stats',
        name: 'stats',
        component: () => import('@/views/admin/stats/stats.vue'),
        meta: { title: '统计' }
      },
      {
        path: 'stats/site/detail',
        name: 'siteStatsDetail',
        component: () => import('@/views/admin/stats/siteDetail.vue'),
        meta: { title: '站点统计详情' }
      },
      {
        path: 'plan',
        name: 'plan',
        component: () => import('@/views/admin/plan/plan.vue'),
        meta: { title: '套餐管理' }
      },
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/admin/order/order.vue'),
        meta: { title: '订单管理', tabbar: 'order' }
      },
      {
        path: 'article',
        name: 'article',
        component: () => import('@/views/admin/article/article.vue'),
        meta: { title: '文章管理' }
      },
      {
        path: 'article/upsert',
        name: 'articleUpsert',
        component: () => import('@/views/admin/article/upsert.vue'),
        meta: { title: '文章编辑' }
      },
      {
        path: 'config',
        name: 'config',
        component: () => import('@/views/admin/config/config.vue'),
        meta: { title: '配置管理' }
      },
      {
        path: 'case/list',
        component: () => import('@/views/admin/case/list.vue'),
        meta: { title: '案例管理' }
      },
      {
        path: 'preMadeVideo/list',
        component: () => import('@/views/admin/preMadeVideo/list.vue'),
        meta: { title: '预制视频' }
      },
      ...site,
      ...agent,
      ...material,
      ...gen,
      ...explore,
      ...asr,
      ...autojs,
      ...creator
    ]
  }
]
